(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description"] && !Shopify.designMode) return;
  try {
    /*
    Tracks clicks on description links tagged with data-ga-event, e.g.
    <a href="/products/new-version" data-ga-event="final_sale_to_new_pdp_click">.
    The attribute value becomes the event name, so new links need no code changes.
    Pushes to dataLayer only: GTM forwards it to GA4 under its own consent settings.
    Delegated from document so it binds once, however many descriptions render.
  */
  (function () {
    function track(event) {
      const link = event.target.closest('.product__description a[data-ga-event]');
      if (!link) return;

      const description = link.closest('.product__description');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: link.dataset.gaEvent,
        source_product_id: description.dataset.productId,
        source_product_handle: description.dataset.productHandle,
        source_url: description.dataset.productUrl,
        destination_url: link.href,
        link_placement: 'product_description',
      });
    }

    document.addEventListener('click', track);
    // Middle-click opens a new tab without firing click.
    document.addEventListener('auxclick', function (event) {
      if (event.button === 1) track(event);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-discount-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    if (e.target.classList.contains('openPopup')) {
      e.preventDefault();
      const overlay = e.target.closest('.storewide-discount-block').nextElementSibling;
      if (overlay && overlay.classList.contains('product-discount-popup-overlay')) {
        overlay.style.display = 'flex';
      }
    }
    if (e.target.classList.contains('product-discount-popup__close') ||
        e.target.closest('.product-discount-popup__close')) {
      const overlay = e.target.closest('.product-discount-popup-overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
    if (e.target.classList.contains('product-discount-popup-overlay')) {
      e.target.style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
